import { useParams, Link } from "react-router-dom";
import { ChevronRight, ArrowRight, Share2, Twitter, Facebook, Linkedin } from "lucide-react";
import { posts } from "../data/site";
import { Reveal } from "../components/Reveal";

export default function BlogDetail() {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);
  if (!post) {
    return (
      <div className="pt-40 pb-24 max-w-4xl mx-auto px-6 text-center">
        Yazı bulunamadı. <Link to="/blog" className="text-[#B8860B]">Bloga dön</Link>
      </div>
    );
  }

  const related = posts.filter((p) => p.slug !== slug).slice(0, 3);

  return (
    <article data-testid="blog-detail" className="pt-32 pb-24 bg-[#FAFAFA]">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-2 text-[11px] tracking-widest uppercase text-[#888] mb-8">
          <Link to="/" className="hover:text-[#B8860B]">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <Link to="/blog" className="hover:text-[#B8860B]">Blog</Link>
          <ChevronRight size={12} />
          <span className="text-[#1E1E1E]">{post.category}</span>
        </div>

        <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-[#888] mb-6">
          <span className="text-[#B8860B]">{post.category}</span>
          <span>·</span>
          <span>{post.date}</span>
          <span>·</span>
          <span>{post.readTime}</span>
        </div>

        <h1 className="font-serif-display text-2xl md:text-4xl text-[#1E1E1E] leading-[1.1]">
          {post.title}
        </h1>

        <div className="mt-8 flex items-center gap-4">
          <img
            src={post.author.avatar}
            alt={post.author.name}
            className="w-11 h-11 rounded-full object-cover"
          />
          <div>
            <div className="text-[14px] text-[#1E1E1E]">{post.author.name}</div>
            <div className="text-[11px] text-[#888]">{post.author.role}</div>
          </div>
          <div className="ml-auto flex items-center gap-2">
            {[Twitter, Facebook, Linkedin].map((I, i) => (
              <button
                key={i}
                className="w-9 h-9 grid place-items-center border border-black/10 hover:border-[#B8860B] hover:text-[#B8860B] transition-colors"
                aria-label="Paylaş"
              >
                <I size={14} />
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 mt-14">
        <div className="clip-frame aspect-[16/9] overflow-hidden">
          <img
            src={post.cover}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <div className="max-w-[900px] mx-auto px-6 lg:px-10 mt-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
        {/* TOC */}
        <aside className="lg:col-span-3 order-2 lg:order-1">
          <div className="lg:sticky lg:top-32">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8860B] mb-4">
              İçindekiler
            </div>
            <ul className="space-y-3 text-[13px] text-[#666]">
              {post.toc.map((t, i) => (
                <li key={i} className="hover:text-[#1E1E1E] transition-colors flex gap-2">
                  <span className="text-[#B8860B]">{String(i+1).padStart(2,'0')}</span> {t}
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <div className="lg:col-span-9 order-1 lg:order-2 space-y-6 text-[16px] text-[#333] leading-[1.9]">
          {post.content.map((c, i) => (
            <p key={i} className={i === 0 ? "text-[19px] text-[#222]" : ""}>
              {c}
            </p>
          ))}
        </div>
      </div>

      {/* Related */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-32">
        <h3 className="font-serif-display text-2xl md:text-3xl text-[#1E1E1E] mb-8">
          Benzer Yazılar
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {related.map((r) => (
            <Link key={r.slug} to={`/blog/${r.slug}`} className="group block">
              <div className="clip-frame aspect-[4/3] overflow-hidden">
                <img src={r.cover} alt={r.title} loading="lazy" className="w-full h-full object-cover img-zoom" />
              </div>
              <div className="mt-4 text-[10px] tracking-widest uppercase text-[#B8860B]">
                {r.category}
              </div>
              <h4 className="mt-1 font-serif-display text-xl text-[#1E1E1E] group-hover:text-[#B8860B] transition-colors">
                {r.title}
              </h4>
            </Link>
          ))}
        </div>
      </div>
    </article>
  );
}
